export var ROUTINE_PROMISE_ACTION = '@@redux-saga-routines/PROMISE';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga-routines/es/constants.js
// module id = 255
// module chunks = 0